const PageComponent = () => import('@/modules/xmsb/component/PageComponent')
const PageApplyStatistics = () => import('@/modules/xmsb/applystatistics/PageApplyStatistics')
const PageTalentSpecialDocument = () => import('@/modules/xmsb/talentspecialdocument/PageTalentSpecialDocument')
const PageTalentSpecial = () => import('@/modules/xmsb/talentspecial/PageTalentSpecial')
const PageTalentsPurchase = () => import('@/modules/xmsb/talentspurchase/PageTalentsPurchase')
const PageLcycSubsidy = () => import('@/modules/xmsb/lcycsubsidy/PageLcycSubsidy')
const PageLjrcSubsidy = () => import('@/modules/xmsb/ljrcsubsidy/PageLjrcSubsidy')
const PageSpecialSubsidy = () => import('@/modules/xmsb/specialsubsidy/PageSpecialSubsidy')

export default [
  {

    path: '/component',
    name: 'component',
    component: PageComponent,
    meta: {
      title: '组件配置',
      isBlack: true
    },
  },
  {

    path: '/applystatistics',
    name: 'applystatistics',
    component: PageApplyStatistics,
    meta: {
      title: '企业申请情况统计',
    },
  },
  {

    path: '/talentspecialdocument',
    name: 'talentspecialdocument',
    component: PageTalentSpecialDocument,
    meta: {
      title: '人才专项文件发布',
      isBlack: true
    },
  },
  {

    path: '/talentspecial',
    name: 'talentspecial',
    component: PageTalentSpecial,
    meta: {
      title: '人才专项',
      isBlack: true
    },
  },
  {

    path: '/lcycsubsidy',
    name: 'lcycsubsidy',
    component: PageLcycSubsidy,
    meta: {
      title: '龙城英才补贴',
      isBlack: true
    },
  },
  {

    path: '/ljrcsubsidy',
    name: 'ljrcsubsidy',
    component: PageLjrcSubsidy,
    meta: {
      title: '领军人才补贴',
      isBlack: true
    },
  },
  {

    path: '/talentspurchase',
    name: 'talentspurchase',
    component: PageTalentsPurchase,
    meta: {
      title: '人才购房补贴',
      isBlack: true
    },
  },
  {
    path: '/specialSubsidy',
    name: 'specialSubsidy',
    component: PageSpecialSubsidy,
    meta: {
      title: '专项补贴',
      isBlack: true
    },
  }
]
